/* eslint-disable no-console */
import { InputError } from "@app/components/core/InputError/InputError"
import { handleKeyboardSelect } from "@app/utils/accessibility"
import "./Checkbox.css"

const Checkbox = ({ checked, label, name, className, formRegister, onClick, value, errors, onChange }) => {
	const errorMessage = formRegister && errors && errors[formRegister.name] ? errors[formRegister.name].message : undefined
	console.log(formRegister)
	return (
		<>
			<div className={"checkbox__move flex flex-item-center primary clickable " + className}>
				<input
					className="rounded-1 flex-shrink-0"
					onChange={onChange}
					value={value}
					type="checkbox"
					name={name}
					onClick={onClick}
					onKeyDown={e => {
						handleKeyboardSelect(e, () => e.target.click())
					}}
					id={name || formRegister ? formRegister?.name : undefined}
					defaultChecked={checked}
					checked={checked}
					{...formRegister}
				/>
				<label htmlFor={name || formRegister ? formRegister?.name : undefined} className="ml-2">
					{label}
				</label>
			</div>
			{formRegister && <InputError message={errorMessage} />}
		</>
	)
}

export { Checkbox }
